var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00033 0.832031C0.987803 0.832031 0.166992 1.65284 0.166992 2.66536C0.166992 3.67789 0.987803 4.4987 2.00033 4.4987C3.01285 4.4987 3.83366 3.67789 3.83366 2.66536C3.83366 1.65284 3.01285 0.832031 2.00033 0.832031ZM1.16699 2.66536C1.16699 2.20513 1.54009 1.83203 2.00033 1.83203C2.46056 1.83203 2.83366 2.20513 2.83366 2.66536C2.83366 3.1256 2.46056 3.4987 2.00033 3.4987C1.54009 3.4987 1.16699 3.1256 1.16699 2.66536Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 2.16536C5.72418 2.16536 5.50033 2.38922 5.50033 2.66536C5.50033 2.94151 5.72418 3.16536 6.00033 3.16536L11.3337 3.16536C11.6098 3.16536 11.8337 2.94151 11.8337 2.66536C11.8337 2.38922 11.6098 2.16536 11.3337 2.16536L6.00033 2.16536Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 7.4987C8.9878 7.4987 8.16699 8.31951 8.16699 9.33203C8.16699 10.3446 8.9878 11.1654 10.0003 11.1654C11.0128 11.1654 11.8337 10.3446 11.8337 9.33203C11.8337 8.31951 11.0128 7.4987 10.0003 7.4987ZM9.16699 9.33203C9.16699 8.87179 9.54009 8.4987 10.0003 8.4987C10.4606 8.4987 10.8337 8.87179 10.8337 9.33203C10.8337 9.79227 10.4606 10.1654 10.0003 10.1654C9.54009 10.1654 9.16699 9.79227 9.16699 9.33203Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 8.83203C0.39085 8.83203 0.166992 9.05589 0.166992 9.33203C0.166992 9.60817 0.39085 9.83203 0.666992 9.83203H6.00033C6.27647 9.83203 6.50033 9.60817 6.50033 9.33203C6.50033 9.05589 6.27647 8.83203 6.00033 8.83203L0.666992 8.83203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select_icon.6adcc571e56ef10d15948fcfe7436c28.svg";
export { ForwardRef as ReactComponent };